import { Sort } from '@/providers/turn/types';
import { Path } from '@/types/global';
import { FCRAWorker, ProfileStatus } from '@/types/turn-api';

export const BLACKLISTED_STATUS: ProfileStatus[] = ['approved', 'rejected'];

export const SORT_OPTIONS: Sort = {
  field: '_doc',
  order: 'DESC',
};

export const path = (path: Path<FCRAWorker.BackgroundCheck>) => path;
